import { z } from 'zod';

const validationSchema = z.object({
  message: z
    .string()
    .min(1, 'Message must contain at least 1 character')
    .refine(val => val.trim().length, {
      message: 'Message must contain at least 1 character, not including space',
    }),
  file: z.instanceof(Blob).optional().nullable(),
});

export default validationSchema;
